<template>
  <div class="smart-alert-page">
    <AlarmOverview :station-id="stationId" :refresh-flag="overviewRefreshFlag"
      @analyze-alarm="handleAnalyzeAlarm" />

    <!-- 智能分析面板 -->
    <AlarmAnalysisPanel v-model="showAnalysisPanel" :alarm-data="selectedAlarm" :station-id="stationId"
      :station-name="stationName" @jump-to-agent="handleJumpToAgent" />
  </div>
</template>

<script setup>
import { ref, inject } from 'vue'
import AlarmOverview from './AlertManagement/AlarmOverview.vue'
import AlarmAnalysisPanel from './AlertManagement/AlarmAnalysisPanel.vue'

// 从父组件获取电站信息
const stationId = inject('stationId', ref(''))
const stationName = inject('stationName', ref(''))

// 智能分析面板状态
const showAnalysisPanel = ref(false)
const selectedAlarm = ref(null)

// 刷新标志
const overviewRefreshFlag = ref(0)

// 处理告警分析
const handleAnalyzeAlarm = (alarm) => {
  selectedAlarm.value = alarm
  showAnalysisPanel.value = true
}

// 跳转到智能体
const handleJumpToAgent = (context) => {
  console.log('Jump to AI agent with context:', context)
}
</script>

<style scoped lang="scss">
.smart-alert-page {
  width: 100%;
  height: 100%;
  min-height: 0;
  display: flex;
  flex-direction: column;
}
</style>
